// extracted by mini-css-extract-plugin
module.exports = {"errorBlock":"style_errorBlock__2yDZ8","icon":"style_icon__MeNLt","error":"style_error__1n0mp"};